import React, { Component } from 'react';

import APIDocsCurl from 'common/developers/docs/api/APIDocsCurl';
import APIDocsMethod from 'common/developers/docs/api/APIDocsMethod';
import Highlight from 'common/developers/docs/api/Highlight';

import APIDocsBlock from '../APIDocsBlock';
import APIDocsTable from '../APIDocsTable';

export default class APIDocsListUsersBlock extends Component {
  createdAt = new Date();

  render() {
    return (
      <APIDocsBlock>
        <div>
          <div className="heading">List users</div>
          <div className="text">Lists a company's users.</div>
          <APIDocsTable
            title="Arguments"
            rows={[
              {
                description: 'Your secret API key.',
                heading: 'apiKey',
                subheading: 'string',
              },
              {
                description:
                  "The number of entries you'd like to fetch. Defaults to 10 if not specified. Maximum value allowed: 100.",
                heading: 'limit',
                subheading: 'number (optional)',
              },
              {
                description:
                  "The number of entries you'd like to skip before starting to fetch. Defaults to 0 if not specified.",
                heading: 'skip',
                subheading: 'number (optional)',
              },
            ]}
          />
          <div className="subheading">Returns</div>
          <div className="text">Returns a list of users.</div>
        </div>
        <div>
          <div className="text">Endpoint</div>
          <Highlight lang="http">https://canny.io/api/v1/users/list</Highlight>
          <APIDocsMethod />
          <APIDocsCurl
            path="https://canny.io/api/v1/users/list"
            body={`\\
    -d apiKey=YOUR_API_KEY \\
    -d limit=100
    -d skip=100`}
          />
          <div className="text">Example Response</div>
          <Highlight lang="json">
            {`[{
  "id": "553c3ef8b8cdcd1501ba123a",
  "alias": "Green Fish",
  "avatarURL": "https://canny.io/images/a3db0133d1e7d9122832b67b2c4caaaa.jpg",
  "created": "${this.createdAt.toISOString()}",
  "customFields": {
    "field1": "value1",
    "field2": "value2"
  },
  "email": "test@test.test",
  "isAdmin": false,
  "lastActivity": "${this.createdAt.toISOString()}",
  "name": "Sally Doe",
  "url": "https://your-company.canny.io/admin/users/sally-doe",
  "userID": "1234"
}]`}
          </Highlight>
        </div>
      </APIDocsBlock>
    );
  }
}
